import { useParams } from "react-router-dom";
import { useSessionCtx } from "../../context/SessionContext.jsx";

const BLANK = "____";
// Matches DashboardPage's own has(): the blank placeholder counts as missing,
// otherwise the hook and the page disagree about what "not provided" means.
const has = (v) => !(v === undefined || v === null || v === "" || v === BLANK);
const val = (v) => (has(v) ? v : BLANK);
const STATUS_LABELS = { 1: "Upcoming", 2: "Live Now", 3: "Postponed", 4: "TBA", 5: "Ended", 6: "On Hold" };
function initialsOf(name) {
  if (!has(name)) return BLANK;
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return BLANK;
  return ((parts[0][0] || "") + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
}

export function useDashboard() {
  const { id } = useParams();
  const ctx = useSessionCtx();
  const session = ctx?.session || null;
  const userDetails = ctx?.userDetails;
  const isUserDetailsLoading = ctx?.isUserDetailsLoading ?? false;
  const S = session || {};
  const detail = S.data?.detail || {};
  const cfg = { hosting: S.data?.hosting || {}, streaming: S.data?.streaming || {} };
  const moderator = userDetails?.data && typeof userDetails.data === "object" ? userDetails.data : {};
  const moderatorHasName = has(moderator.name);
  const moderatorInitials = initialsOf(moderator.name);
  const statusLabel = val(STATUS_LABELS[detail.status]);
  const specialityText = Array.isArray(detail.specialities) && detail.specialities.length ? detail.specialities.map((sp) => sp?.name).filter(Boolean).join(", ") : "";
  const speakers = Array.isArray(detail.speakers) ? detail.speakers.map((s, i) => ({ id: s?.id ?? i, name: val(s?.name), speciality: val(s?.speciality || s?.designation), avatar: initialsOf(s?.name) })) : [];
  const aboutText = has(detail.agenda) ? detail.agenda : detail.description;
  const details = [
    { label: "Type", value: val(detail.tenet) },
    { label: "Speciality", value: val(specialityText) },
    { label: "Credit", value: has(detail.creditPoints) ? (has(detail.creditType) ? `${detail.creditPoints} ${detail.creditType}` : String(detail.creditPoints)) : BLANK },
    { label: "Status", value: statusLabel },
    { label: "Start Time", value: val(detail.startTime) },
    { label: "End Time", value: val(detail.endTime) },
    { label: "Session ID", value: val(S.sessionId) },
  ];
  const certificateLabel = has(detail.certificateavailable) ? (detail.certificateavailable ? "Enabled" : "Disabled") : BLANK;
  const tags = Array.isArray(detail.specialities) ? detail.specialities.map((sp) => sp?.name).filter(Boolean) : [];
  const title = val(detail.title);
  const startTime = val(detail.startTime);
  const endTime = val(detail.endTime);
  const platformId = val(detail.tenet);
  return { id, S, cfg, moderator, moderatorHasName, moderatorInitials, isUserDetailsLoading, statusLabel, specialityText, speakers, aboutText, details, certificateLabel, tags, title, startTime, endTime, platformId, BLANK, has, val, initialsOf };
}
